import { z as builder } from "zod"

export const unlockSchema = builder.object({
    phoneNumber: builder.string().min(10).max(10)
})
